import React, { ChangeEvent, KeyboardEvent, useState } from 'react';
import Text from 'components/Text';
import { Row, Column } from 'components/Layout/Grid';
import FloatingLabel from 'components/FloatingLabel';
import { TagSimpleProps } from './interface';

import { InputTag } from './styles';

export const TagSimple: React.FC<TagSimpleProps> = (props) => {
  const { tags, setTags } = props;
  const [tagInput, setTagInput] = useState('');

  const addNewTag = (e: KeyboardEvent<HTMLInputElement>) => {
    const code = e.keyCode;

    if (!tagInput) return;

    if (code === 13 || code === 188) {
      e.preventDefault();
      setTags((data: string[]) => [...data, tagInput]);
      setTagInput('');
    } else {
      return true;
    }
  };

  const removeTag = (id: number) => {
    const _tags: Array<string> = tags;

    _tags.splice(id, 1);

    return setTags([...tags]);
  };

  return (
    <Column className="mt-5">
      <Text className="mb-2 color-blue-gray" size={12}>
        Adicionar Tags
      </Text>
      <Row
        className="mb-2 flex-1 align-center px-2 flex-wrap"
        style={{ borderRadius: 6, border: '1px solid #a0a0a0' }}
      >
        {tags?.map((tag: string, _: number) => (
          <FloatingLabel
            key={_}
            label={tag}
            index={_}
            onRemove={removeTag}
          />
        ))}
        <InputTag
          onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => addNewTag(e)}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setTagInput(e.target.value)}
          value={tagInput}
        />
      </Row>
    </Column>
  );
};